import { Component, type ReactNode } from 'react';
import { recordError } from './feedback';

declare const __APP_VERSION__: string;

/** Když obrazovka spadne na chybě, ukáže místo prázdné stránky vysvětlení a tlačítko. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    recordError(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="content error-boundary" style={{ paddingTop: 40 }}>
        <h1 style={{ fontSize: 22 }}>Něco se nepovedlo</h1>
        <p>Vaše data jsou v pořádku. Zkuste se vrátit na úvod nebo aplikaci načíst znovu.</p>
        <div className="quick-row">
          <button
            className="btn primary"
            onClick={() => {
              location.hash = '#/';
              location.reload();
            }}
          >
            Na úvod
          </button>
          <button className="btn" onClick={() => location.reload()}>
            Načíst znovu
          </button>
          <button
            className="btn"
            onClick={() => {
              location.hash = '#/pripominky?chyba=1';
              location.reload();
            }}
          >
            Nahlásit chybu
          </button>
        </div>
        <p className="muted small">
          Verze {__APP_VERSION__} · {String(this.state.error.message || this.state.error)}
        </p>
      </div>
    );
  }
}
